export const DATA_TYPE_KEY = 'aem_data_type' as const
export const FILE_ASSETS_AEM_DATA_TYPE_KEY = 'file_assets' as const
export const PAGES_AEM_DATA_TYPE_KEY = 'pages' as const

export const supportedFileTypesForFiltering = [
  { label: 'BMP', value: 'image/bmp' },
  { label: 'DOC', value: 'application/msword' },
  {
    label: 'DOCX',
    value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  {
    label: 'HTML',
    value: 'text/html',
  },
  { label: 'GIF', value: 'image/gif' },
  { label: 'JPEG', value: 'image/jpeg' },
  { label: 'MP3', value: 'audio/mpeg' },
  { label: 'MP4', value: 'video/mp4' },
  { label: 'MPEG', value: 'video/mpeg' },
  { label: 'PDF', value: 'application/pdf' },
  { label: 'PNG', value: 'image/png' },
  { label: 'PPT', value: 'application/vnd.ms-powerpoint' },
  {
    label: 'PPTX',
    value: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  { label: 'SVG', value: 'image/svg+xml' },
  { label: 'TIFF', value: 'image/tiff' },
  { label: 'WAV', value: 'audio/wav' },
  { label: 'XLS', value: 'application/vnd.ms-exce' },
  { label: 'XLSX', value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
] as const
